import { render, staticRenderFns } from "./qualificationProof.vue?vue&type=template&id=b8cd8ad2&scoped=true&"
import script from "./qualificationProof.vue?vue&type=script&lang=js&"
export * from "./qualificationProof.vue?vue&type=script&lang=js&"
import style0 from "./qualificationProof.vue?vue&type=style&index=0&id=b8cd8ad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cd8ad2",
  null
  
)

export default component.exports